import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ROUTES } from '@shared/constants/routes';

@Component({
  selector: 'app-footer',
  imports: [TranslatePipe],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer {
  ROUTES = ROUTES;
  constructor(
    private router: Router
  ) {}


  getPublicPath(route: string) {
    return `/${route}`
  }
}
